// extracted by mini-css-extract-plugin
module.exports = {"container":"ElBacko_container__3jcG8","content":"ElBacko_content__2KCW2"};